module.exports = {"411323001":"白羽街道","411323002":"紫金街道","411323003":"莲花街道","411323101":"丹水镇","411323102":"西坪镇","411323103":"双龙镇","411323104":"回车镇","411323105":"丁河镇","411323106":"桑坪镇","411323107":"米坪镇","411323108":"五里桥镇","411323109":"重阳镇","411323110":"太平镇","411323111":"阳城镇","411323112":"二郎坪镇","411323113":"石界河镇","411323114":"军马河镇","411323300":"田关乡","411323307":"寨根乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411323.json
// module id = 1642
// module chunks = 0